import React, { useState, useImperativeHandle, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { openNewTab } from '../../../services/commons';
import {
  Modal,
  Loading,
  PdfIcon,
  PdfOKIcon,
} from '../../../components';
import * as Ui from './styles';
import ReportProcessing from './ReportProcessing';
import { useErrorToast } from '../../../hooks';

/**
 * Componente de modal que serve como gatilho e
 * forma de representacao sobre o estado do processamento
 * do relatorio de resultados
 */

const propTypes = {
  onFinish: PropTypes.func,
};
function ReportModalReferenciable(props, ref) {
  // state from props
  const { onFinish } = props;

  // ref
  const reportProcessingRef = useRef();

  // state
  const [showModal, setShowModal] = useState(false);
  const [reportUrl, setReportUrl] = useState(null);
  // armazena os dados passados pelo parent para execução do buildReportPayload
  const [reportData, setReportData] = useState(null);

  // hooks
  const [checkError] = useErrorToast();

  /**
     * Expondo funcoes a serem utilizadas via ref
     */
  useImperativeHandle(ref, () => ({
    buildReportPayload: (customerId, surveyId) => {
      setShowModal(true);
      setReportData({ customerId, surveyId });
    },
  }));

  /**
     * Callback executado quando o showModal for alterado, para garantir que a ref do componente
     * ReportProcessing exista ao executar o buildReportPayload
     */
  useEffect(() => {
    if (reportProcessingRef.current && showModal && reportData) {
      reportProcessingRef.current.buildReportPayload(reportData.customerId, reportData.surveyId);
    }
  }, [showModal, reportData]);

  /**
     * Callback executado quando o processamento do relatorio
     * eh concluido e esta disponivel para accesso
     */
  function onReportDone(reportUrl) {
    setReportUrl(reportUrl);
  }

  function clearComponent() {
    setShowModal(false);
    setReportData(null);
    setReportUrl(null);
  }

  /**
     * Conclui a operacao no componente, limpando o componente
     * e notificando o parent component
     */
  function finish() {
    clearComponent();
    onFinish && onFinish();
  }

  function onReportFail(error, message = null) {
    checkError(error, message);
    finish();
  }

  /**
     * Abre o relatorio em uma nova janela e fecha o modal
     * atual
     */
  function openReportUrl() {
    openNewTab(reportUrl);
  }

  function renderReportBody() {
    return (
      <Ui.ModalBody>
        <PdfOKIcon size={30} />
        <p>Relatório gerado com sucesso, por favor, prossiga</p>
      </Ui.ModalBody>
    );
  }

  function renderReportLoadingBody() {
    return (
      <Ui.ModalBody>
        <Loading size={30} running />
        <p>Aguarde um momento, estamos estruturando seu relatório...</p>
      </Ui.ModalBody>
    );
  }

  return (
    showModal ? (
      <Ui.Container className="ReportModal.Container">
        <ReportProcessing ref={reportProcessingRef} onReportDone={onReportDone} onReportFail={onReportFail} />
        {/*
          As acoes ficam sempre visiveis para o usuario ter como fechar a modal
          se a geracao falhar; o ABRIR so aparece quando a url esta pronta
        */}
        <Modal
          isOpen
          title="GERADOR DE RELATÓRIO"
          showActions
          hiddenOkButton={reportUrl == null}
          onOk={openReportUrl}
          onCancel={finish}
          okBtnTitle="ABRIR"
          cancelBtnTitle="FECHAR"
          iconComponent={PdfIcon}
          width={'540px'}
          contentHeight={'250px'}
        >
          {
            reportUrl != null ? renderReportBody() : renderReportLoadingBody()
          }
        </Modal>
      </Ui.Container>
    ) : null
  );
}

const ReportModal = React.forwardRef(ReportModalReferenciable);
ReportModal.propTypes = propTypes;
export default ReportModal;
